import { getCsrfValue } from "~/common/utils/ApiHelper";
import { prepareCommonLinearData } from "~/features/configurator/Linear/api/sendLinearCommon";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type PriceInfo } from "~/domains/pricing/api/PriceInfo";

export function sendLinearAddToCart(
  linearState: LinearConfiguratorState,
  priceInfo: PriceInfo | null,
): Promise<string> {
  const data = prepareCommonLinearData(linearState, priceInfo);

  return fetch(window.location.href.substring(0, window.location.href.lastIndexOf("/")) + "/addToCart2", {
    body: JSON.stringify(data),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((result) => {
    if (result.ok) {
      return result.json();
    } else {
      console.error(`Error sending linear update: ${result.status}`);
      throw new Error(result.status + "");
    }
  });
}
